import i18next from 'i18next';
import React, { FC, ReactElement, useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Link, NavLink, useNavigate } from 'react-router';
import { useExtendedAuth } from '../util/auth0';
import { fetchUserAccountRemote } from '../util/UserAccount';
import { useAuthFetchFromRestAPI } from '../util/api';
import { useAuth0 } from '@auth0/auth0-react';

const Header: FC = () => {
  const { authFetch } = useAuthFetchFromRestAPI();
  const { user, logout } = useAuth0();
  const { isAdminUser, isSuperAdminUser } = useExtendedAuth();
  const [notAllowedFeature, setNotAllowedFeature] = useState<string[]>([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 720);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  
  const handleResize = (): void => {
    if (window.innerWidth < 720) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  const topNavIcon = <img src="/themes/physio/logo.png" alt="Room4Physio" />;
  const getUserProfile = (): void => {
    fetchUserAccountRemote(authFetch).then((profileResponse) => {
      if (profileResponse && profileResponse.notAllowedFeature) {
        setNotAllowedFeature(profileResponse.notAllowedFeature);
      }
    });
  };
  useEffect(() => {
    getUserProfile();
  }, [user]);
  // workaround to avoid nested "a" elements
  const navigate = useNavigate();

  const localLogout = async (): Promise<void> => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('user');
    localStorage.removeItem('_online_');

    await logout({ logoutParams: { returnTo: window.location.origin } });
  };
  useEffect(() => {
    window.addEventListener('resize', handleResize);
  });

  useEffect(() => {
    const checkUserPermissions = async (): Promise<void> => {
      setIsAdmin(await isAdminUser());
      setIsSuperAdmin(await isSuperAdminUser());
    };

    void checkUserPermissions();
  }, [user]);

  const mobileMenu = (): ReactElement => {
    return (
      <>
        <DropdownButton
          variant="link"
          size="lg"
          title={<i className="fas fa-bars" aria-hidden="true" />}
          id="mobile-dropdown"
        >
          <Dropdown.Item onClick={() => navigate('/patients')} eventKey="patients">
            {i18next.t('header.patientsNav')}
          </Dropdown.Item>
          <Dropdown.Item onClick={() => navigate('/appointments')} eventKey="appointments">
            {i18next.t('header.appointments')}
          </Dropdown.Item>
          {notAllowedFeature.indexOf('CHAT')<0 ? <Dropdown.Item onClick={() => navigate('/messages')} eventKey="messages">
            <span id="notificationTextBold" >{i18next.t('header.messages')}</span>
            <span id="notificationBadge" className='notification-dot-big ms-2 d-none'>1</span>
          </Dropdown.Item> : null}
          {isAdmin ?
            <Dropdown.Item onClick={() => navigate('/admin')} eventKey="admin">
              {i18next.t('header.adminNav')}
            </Dropdown.Item> :
            null
          }
          {isSuperAdmin ?
            <Dropdown.Item onClick={() => navigate('/super-admin')} eventKey="super-admin">
              {i18next.t('header.superAdminNav')}
            </Dropdown.Item> :
            null
          }
          <Dropdown.Item onClick={() => navigate('/account')} eventKey="account">
            {i18next.t('header.myAccountNav')}
          </Dropdown.Item>
          <Dropdown.Item onClick={localLogout} eventKey="logout">
            {i18next.t('header.logoutNav')}
          </Dropdown.Item>
        </DropdownButton>);
      </>);
  };
  const webMenu = (): ReactElement => {
    return (<>
      <NavLink to="/patients">{i18next.t('header.patientsNav')}</NavLink>
      <NavLink to="/appointments">{i18next.t('header.appointments')}</NavLink>
      {notAllowedFeature.indexOf('CHAT')<0 ?
        <NavLink to="/messages">
          <span id="notificationTextBold" >{i18next.t('header.messages')}</span>
          <span id="notificationBadge" className='notification-dot-big ms-2 d-none'>1</span>
        </NavLink>
        :null
      }
      {isAdmin ? <NavLink to="/admin">{i18next.t('header.adminNav')}</NavLink> : null}
      {isSuperAdmin ? <NavLink to="/super-admin">{i18next.t('header.superAdminNav')}</NavLink> : null}
      <DropdownButton
        variant="link"
        size="lg"
        title={<i className="fa fa-user-circle" aria-hidden="true" />}
        id="logout-dropdown"
      >
        <Dropdown.Item onClick={() => navigate('/account')} eventKey="account">
          {i18next.t('header.myAccountNav')}
        </Dropdown.Item>
        <Dropdown.Item onClick={localLogout} eventKey="logout">
          {i18next.t('header.logoutNav')}
        </Dropdown.Item>
      </DropdownButton>
    </>);
  };

  return (
    <nav className="app-header-nav">
      <Link className="logo" to="/">
        {topNavIcon}
      </Link>
      <div>
        {isMobile ? mobileMenu() : webMenu()}
      </div>
    </nav>
  );
};

export default Header;
